module.exports = __webpack_public_path__ + "ced9764f91e6dc4fd185c8920a207d2f.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.html
// module id = 2608
// module chunks = 0